// extracted by mini-css-extract-plugin
module.exports = {"base":"SettingsAccount_base__2FZMf","avatar":"SettingsAccount_avatar__HI44F","row":"SettingsAccount_row__2F3e6","info":"SettingsAccount_info__2pXPn"};